import { Directive, HostBinding, HostListener } from '@angular/core';

/**
 * 讓非真實導覽的連結（靠 (click) 開對話框/下載/查詢，而非 <a href>）點擊後模擬瀏覽器 :visited 變色效果。
 * 做法：click 時把 `clicked` 設為 true，透過 host class binding 加上 `link-visited`，由全域 CSS 的
 * `.link.link-visited` 規則變色；重新查詢/整頁重整時 Angular 重建 host 元素（或 *ngFor/*ngIf 重新建立），
 * 指令實例隨之重建，`clicked` 回到預設值 false，顏色自動恢復原狀。
 * 使用時仍需在對應的樣式檔（全域或該元件的 scoped scss）補上 `.link.link-visited` 規則。
 */
@Directive({
  selector: '[sigvVisitedLink]',
})
export class VisitedLinkDirective {
  @HostBinding('class.link-visited') clicked = false;

  @HostListener('click')
  onClick(): void {
    this.clicked = true;
  }
}
